var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoSemicircles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 123,
    viewBox: "0 0 150 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1.23978e-05L125 1.23978e-05C119.419 40.9208 88.5659 49.601 73.8372 48.826C36.6278 48.826 25.7752 16.2754 25 1.23978e-05Z",
    fill: "#503AC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 122.18L150 122.18C141.628 60.7992 95.3489 47.7789 73.2558 48.9415C17.4417 48.9415 1.16278 97.7675 0 122.18Z",
    fill: "#17FFD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSemicircles);
export default __webpack_public_path__ + "static/media/two-semicircles.aab5e7bfc3de67499302a3364b40da5f.svg";
export { ForwardRef as ReactComponent };